
import { useState } from 'react';
import TopNavigation from '../../components/feature/TopNavigation';
import BottomNavigation from '../../components/feature/BottomNavigation';
import Button from '../../components/base/Button';

export default function HistoryPage() {
  const [activeFilter, setActiveFilter] = useState('all');

  const filters = [
    { id: 'all', label: 'الكل' },
    { id: 'found', label: 'تم العثور' },
    { id: 'not_found', label: 'لم توجد نتيجة' },
  ];

  const historyItems = [
    {
      id: 1,
      plateNumber: 'أ ب ج 1234',
      date: '2024-01-15',
      status: 'found',
      statusText: 'تم العثور'
    },
    {
      id: 2,
      plateNumber: 'د هـ و 5678',
      date: '2024-01-14',
      status: 'not_found',
      statusText: 'لم توجد نتيجة'
    },
    {
      id: 3,
      plateNumber: 'ز ح ط 9012',
      date: '2024-01-13',
      status: 'found',
      statusText: 'تم العثور'
    },
  ];

  const filteredItems = activeFilter === 'all' 
    ? historyItems 
    : historyItems.filter(item => item.status === activeFilter);

  const stats = {
    total: historyItems.length,
    found: historyItems.filter(item => item.status === 'found').length,
    notFound: historyItems.filter(item => item.status === 'not_found').length,
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-gray-100">
      <TopNavigation title="اخر السجلات" />
      
      <div className="pt-24 pb-24 px-6">
        {/* Statistics Cards */}
        <div className="grid grid-cols-3 gap-4 mb-8">
          <div className="bg-white rounded-xl p-4 text-center shadow-sm border border-gray-100">
            <div className="text-2xl font-bold text-purple-600 mb-1">{stats.total}</div>
            <div className="text-xs text-gray-600">إجمالي البحثات</div>
          </div>
          <div className="bg-white rounded-xl p-4 text-center shadow-sm border border-gray-100">
            <div className="text-2xl font-bold text-green-600 mb-1">{stats.found}</div>
            <div className="text-xs text-gray-600">تم العثور</div>
          </div>
          <div className="bg-white rounded-xl p-4 text-center shadow-sm border border-gray-100">
            <div className="text-2xl font-bold text-red-500 mb-1">{stats.notFound}</div>
            <div className="text-xs text-gray-600">لم توجد</div>
          </div>
        </div>

        {/* Filter Tabs */}
        <div className="bg-white rounded-xl p-2 mb-6 shadow-sm border border-gray-100">
          <div className="grid grid-cols-3 gap-1">
            {filters.map((filter) => (
              <button
                key={filter.id}
                onClick={() => setActiveFilter(filter.id)}
                className={`py-3 px-4 rounded-lg text-sm font-medium transition-all duration-200 ${
                  activeFilter === filter.id
                    ? 'bg-purple-600 text-white shadow-md'
                    : 'text-gray-600 hover:bg-gray-50'
                }`}
              >
                {filter.label}
              </button>
            ))}
          </div>
        </div>

        {/* History List */}
        <div className="space-y-4">
          {filteredItems.length > 0 ? (
            filteredItems.map((item) => (
              <div key={item.id} className="bg-white rounded-xl p-5 shadow-sm border border-gray-100">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3 space-x-reverse">
                    <button className="text-purple-600 hover:text-purple-800 p-1">
                      <i className="ri-arrow-left-line text-lg w-5 h-5 flex items-center justify-center"></i>
                    </button>
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                      item.status === 'found'
                        ? 'bg-green-100 text-green-700'
                        : 'bg-red-100 text-red-700'
                    }`}>
                      {item.statusText}
                    </span>
                  </div>
                  <div className="flex-1 text-right mr-4">
                    <p className="font-bold text-gray-900 text-lg mb-2">
                      {item.plateNumber}
                    </p>
                    <p className="text-sm text-gray-500">
                      {item.date}
                    </p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-12">
              <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-search-line text-gray-400 text-2xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                لا توجد نتائج
              </h3>
              <p className="text-gray-600 mb-6">
                لم يتم العثور على بحثات بالفلتر المحدد
              </p>
              <Button
                onClick={() => setActiveFilter('all')}
                variant="outline"
                size="sm"
              >
                عرض جميع البحثات
              </Button>
            </div>
          )}
        </div>

        {/* Upgrade Banner */}
        <div className="mt-8 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl p-6 text-white text-center">
          <h3 className="text-lg font-bold mb-2">ترقية حسابك</h3>
          <p className="text-purple-100 mb-4 text-sm">
            احصل على بحثات غير محدودة
          </p>
          <Button
            className="bg-white text-purple-600 hover:bg-gray-50 font-semibold"
            size="sm"
          >
            ترقية
          </Button>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
}
